export const environment = {
    iam: {
        clientId: '3-b-AIM-Portal-UAT-6BT06S53774FC8B',
        issuer: 'https://gem.okta-emea.com/oauth2/aus2jp8vmz3yYrDnc0i7',

        redirectUri: 'https://instructflow.apps.noprod.gems.engie.co.uk/callback',
        logoutUrl: 'https://instructflow.apps.noprod.gems.engie.co.uk/logout',
        postLogoutRedirectUri: 'https://instructflow.apps.noprod.gems.engie.co.uk/logout',
        responseType: 'code',
        // tslint:disable-next-line: max-line-length
        scope: 'openid profile email api.aim-portal',
        showDebugInformation: true,
        sessionChecksEnabled: true,
        nonceStateSeparator: ';',
        useSilentRefresh: true,
        fallbackAccessTokenExpirationTimeInSec: 3600,
        silentRefreshRedirectUri: 'https://instructflow.apps.noprod.gems.engie.co.uk/assets/silent-refresh.html',
        tokenEndpoint: 'https://gem.okta-emea.com/oauth2/aus2jp8vmz3yYrDnc0i7/v1/token'
    },
    production: false,
//    apiUrl: 'https://localhost:44313/',
    apiUrl: 'https://instructflow.ems.api.noprod.engie.co.uk/',
    oktaConfig: {
        additionalScopes: ['openid', 'profile', 'email', 'api.aim-portal'],
        clientId: '3-b-AIM-Portal-UAT-6BT06S53774FC8B',
        interceptUrls: [
            'https://instructflow.ems.api.noprod.engie.co.uk'
        ],
        tenantId: 'aus2jp8vmz3yYrDnc0i7',
        interceptAddContentHeader: false,
        url: 'https://gem.okta-emea.com',
        withPath: false,
    },
    env: 'local',
    groups: {
        trader: "uat-aim-traders",
        moray_east: "uat-aim-moray-east",
        moray_west: "uat-aim-moray-west",
        retail: "uat-aim-retail",
        readonly: "uat-aim-read-only",
        fhc: "uat-aim-fhc",
        archiver: "uat-aim-archiver",
        res: "uat-aim-res"
    }
}